import styled from '@emotion/styled';

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const Growing = styled.div`
    flex: 1;
`;
